import { render, staticRenderFns } from "./DocumentViewHeader.vue?vue&type=template&id=4e85423e&scoped=true"
import script from "./DocumentViewHeader.vue?vue&type=script&lang=js"
export * from "./DocumentViewHeader.vue?vue&type=script&lang=js"
import style0 from "./DocumentViewHeader.vue?vue&type=style&index=0&id=4e85423e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e85423e",
  null
  
)

export default component.exports